import React, { useState } from "react";

import Index from "./pages/Index";
import Room1 from "./pages/Room1";
import Room2 from "./pages/Room2";
import Room3 from "./pages/Room3";
import Room4 from "./pages/Room4";
import Room5 from "./pages/Room5";
import Room6 from "./pages/Room6";
import Room7 from "./pages/Room7";
import Room8 from "./pages/Room8";
import Room9 from "./pages/Room9";
import Room10 from "./pages/Room10";
import Room11 from "./pages/Room11";
import Room12 from "./pages/Room12";
import Room13 from "./pages/Room13";
import Room13b from "./pages/Room13b";
import Room14 from "./pages/Room14";
import Room16 from "./pages/Room16";
import Room17 from "./pages/Room17";
import Room18 from "./pages/Room18";
import Room19 from "./pages/Room19";
import Room20 from "./pages/Room20";
import Room21 from "./pages/Room21";
import Treasure from "./pages/Treasure";

export default function Caves() {
  const [activeTab, setActiveTab] = useState("index");

  // A mapping to track the previous tab for "Go Back" functionality
  const tabHistory = {
    room1: "index",
    room2: "room1",
    room3: "room1",
    room4: "room1",
    room5: "room3",
    room6: "room3",
    room7: "room4",
    room8: "room4",
    room9: "room6",
    room10: "room6",
    room11: "room5",
    room12: "room5",
    room13: "room7",
    room13b: "room13",
    room14: "room7",
    room16: "room8",
    room17: "room16",
    room18: "room16",
    room19: "room16",
    room20: "room13b",
    room21: "room13b",
  };

  const goBack = () => {
    setActiveTab(tabHistory[activeTab] || "index");
  };

  return (
    <div>
      <main style={{ margin: "0px", padding: "0px" }}>
        {activeTab === "index" && <Index enterRoom1={() => setActiveTab("room1")} />}
        {activeTab === "room1" && (
          <Room1
            goToRoom2={() => setActiveTab("room2")}
            goToRoom3={() => setActiveTab("room3")}
            goToRoom4={() => setActiveTab("room4")}
            goBack={goBack}
          />
        )}
        {activeTab === "room2" && (
          <Room2
            goBack={goBack}
          />
        )}
        {activeTab === "room3" && (
          <Room3
            goToRoom5={() => setActiveTab("room5")}
            goToRoom6={() => setActiveTab("room6")}
            goBack={goBack}
          />
        )}
        {activeTab === "room4" && (
          <Room4
            goToRoom7={() => setActiveTab("room7")}
            goToRoom8={() => setActiveTab("room8")}
            goBack={goBack}
          />
        )}
        {activeTab === "room5" && (
          <Room5
            goToRoom11={() => setActiveTab("room11")}
            goToRoom12={() => setActiveTab("room12")}
            goBack={goBack}
          />
        )}
        {activeTab === "room6" && (
          <Room6
            goToRoom9={() => setActiveTab("room9")}
            goToRoom10={() => setActiveTab("room10")}
            goBack={goBack}
          />
        )}
        {activeTab === "room7" && (
          <Room7
            goToRoom13={() => setActiveTab("room13")}
            goToRoom14={() => setActiveTab("room14")}
            goBack={goBack}
          />
        )}
        {activeTab === "room8" && (
          <Room8
            goToRoom16={() => setActiveTab("room16")}
            goBack={goBack}
          />
        )}
        {activeTab === "room9" && (
          <Room9
            goBack={goBack}
          />
        )}
        {activeTab === "room10" && (
          <Room10
            goBack={goBack}
          />
        )}
        {activeTab === "room11" && (
          <Room11
            goBack={goBack}
          />
        )}
        {activeTab === "room12" && (
          <Room12
            goBack={goBack}
          />
        )}
        {activeTab === "room13" && (
          <Room13
            goToRoom13b={() => setActiveTab("room13b")}
            goBack={goBack}
          />
        )}
        {activeTab === "room13b" && (
          <Room13b
            goToRoom20={() => setActiveTab("room20")}
            goToRoom21={() => setActiveTab("room21")}
            goBack={goBack}
          />
        )}
        {activeTab === "room14" && (
          <Room14
            goBack={goBack}
          />
        )}
        {activeTab === "room16" && (
          <Room16
            goToRoom17={() => setActiveTab("room17")}
            goToRoom18={() => setActiveTab("room18")}
            goToRoom19={() => setActiveTab("room19")}
            goBack={goBack}
          />
        )}
        {activeTab === "room17" && (
          <Room17
            goBack={goBack}
          />
        )}
        {activeTab === "room18" && (
          <Room18
            goBack={goBack}
          />
        )}
        {activeTab === "room19" && (
          <Room19
            goBack={goBack}
          />
        )}
        {activeTab === "room20" && (
          <Room20
            goBack={goBack}
          />
        )}
        {activeTab === "room21" && (
          <Room21
            goToIndex={() => setActiveTab("treasure")}
            goBack={goBack}
          />
        )}
        {activeTab === "treasure" && (
          <Treasure/>
        )}
      </main>
    </div>
  );
}